const headquarterLang = {
  en: {
    headquarter: "Residence / Program",
    headquarters: "Residence / Program",
    sureDeletedHeadquarter: "Are you sure to delete the residence / program?",
    codeHeadquarter: "Code",
    codeRequiredHeadquarter: "Code is a required field",
    nameHeadquarter: "Name",
    nameRequiredHeadquarter: "Name is a required field",
    descriptionHeadquarter: "Description",
    countryHeadquarter: "Country",
    stateHeadquarter: "State",
    countryRequiredHeadquarter: "Country is a required field",
    headquarters_insert_succesful: "The residence / program has entered correctly",
    headquarters_updated_successful: "The residence / program has updated correctly",
    headquarters_deleted_successful: "The residence / program has been deleted",
    stateHeadquarterRequired: "State is a required field",
    headquarters_departament_insert_succesful:
      "The state has entered correctly",
    headquarters_ubication_insert_succesful:
      "The location has entered correctly",
    headquarters_ubication_deleted_successful:
      "The location has deleted correctly",
    headquarters_ubication_updated_successful:
      "The location has updated correctly",
  },
  es: {
    headquarter: "Residencia / Programa",
    headquarters: "Residencia / Programa",
    sureDeletedHeadquarter: "¿Esta seguro de eliminar la residencia / programa?",
    codeHeadquarter: "Código",
    codeRequiredHeadquarter: "Código es un campo requerido",
    nameHeadquarter: "Nombre",
    nameRequiredHeadquarter: "Nombre es un campo requerido",
    descriptionHeadquarter: "Descripción",
    countryHeadquarter: "País",
    stateHeadquarter: "Departamento",
    countryRequiredHeadquarter: "País es un campo requerido",
    headquarters_insert_succesful: "La residencia / programa se ha ingresado correctamente",
    headquarters_updated_successful: "La residencia / programa se ha  actualizado correctamente",
    headquarters_deleted_successful: "La residencia / programa ha sido eliminada",
    stateHeadquarterRequired: "Departamento es un campo requerido",
    headquarters_departament_insert_succesful:
      "El departamento se ha ingresado correctamente",
    headquarters_ubication_insert_succesful:
      "La ubicación se ha ingresado correctamente",
    headquarters_ubication_deleted_successful:
      "La ubicación se ha eliminado correctamente",
    headquarters_ubication_updated_successful:
      "La ubicación se ha actualizado correctamente",
  },
};

export default headquarterLang;
